import type { ReactNode } from 'react';

import { Dropdown } from '#/components/Dropdown/Dropdown';
import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';

import { ParticipateDropdownMenu } from './ParticipateDropdownMenu';

type Props = {
  renderTrigger: (data: {
    triggerText: string;
    triggerHref: string;
  }) => ReactNode;
  trackClickedContext: string;
};

const triggerTextByLocale: Record<
  I18nLocale.ES | I18nLocale.PT,
  { text: string; href: string }
> = {
  es: {
    text: 'Participa',
    href: '/es/dias/participa',
  },
  pt: {
    text: 'Participar',
    href: '/pt/movimento',
  },
};

export function ParticipateDropdown({
  renderTrigger,
  trackClickedContext,
}: Props) {
  const { locale } = useI18n();

  if (locale !== I18nLocale.ES && locale !== I18nLocale.PT) {
    return;
  }

  const { text, href } = triggerTextByLocale[locale];

  return (
    <Dropdown
      trigger={renderTrigger({ triggerText: text, triggerHref: href })}
      desktopTriggersOnHover
    >
      <ParticipateDropdownMenu trackClickedContext={trackClickedContext} />
    </Dropdown>
  );
}
